import { Type } from '@angular/core';
import { ConfigurationId } from '@types';
import { FundPerformanceCumulativeComponent } from './fund-performance-cumulative/fund-performance-cumulative.component';
import { FundPerformanceDisplayComponent } from './fund-performance-display-component.interface';

export class FundPerformanceComponentConfig {
  static readonly FUND_PERFORMANCE_CUMULATIVE = new FundPerformanceComponentConfig(
    'Cumulative',
    FundPerformanceCumulativeComponent,
    ConfigurationId.GW
  );

  static allConfigs: FundPerformanceComponentConfig[] = [
    FundPerformanceComponentConfig.FUND_PERFORMANCE_CUMULATIVE,
  ];

  // returns matching config or undefined
  static getConfig(key: string): FundPerformanceComponentConfig {
    return this.allConfigs.find(
      (config: FundPerformanceComponentConfig): boolean => config.key === key
    ); // otherwise just match on key
  }

  private constructor(
    private readonly key: string,
    public readonly component: Type<FundPerformanceDisplayComponent>,
    public readonly configurationName?: ConfigurationId
  ) {}
}
